import React, { Component } from "react";
import { connect } from "react-redux";
import { votingOpenToggle } from "../../actions/debateActions";

class VotingOpen extends Component {
  handleClick = (vType, cCode) => {
    this.props.votingOpenToggle(vType, cCode);
  };

  render() {
    const { cCode } = this.props.location.params || {};
    const { votingType } = this.props;
    const theVotingType = this.props[votingType][cCode] || {};
    return (
      <div className="row mt-5">
        <div className="col-12">
          <button
            className={`btn btn-${
              theVotingType.open ? "danger" : "primary"
            } btn-block w-100 mx-auto`}
            style={{ maxWidth: 500 }}
            onClick={() => this.handleClick(votingType, cCode)}
          >
            {theVotingType.open ? "종료하기" : "시작하기"}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  location: state.location,
  earlyVoting: state.earlyVoting,
  awards: state.awards,
  finalVoting: state.finalVoting,
  feedback: state.feedback
});

export default connect(
  mapStateToProps,
  { votingOpenToggle }
)(VotingOpen);
